<section id="wrapper" class="error-page">
    <div class="error-box">
        <div class="error-body text-center">
            <h1>404</h1>
            <h3 class="text-uppercase">Pagína no encontrada !</h3>
        </div>

    </div>
</section>
<footer class="footer text-center">© {{ anio }} Administración 360.</footer>